export default "__VITE_ASSET__CZy2Ol6H__"